import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../services/api";
import "../styles/registro.css";
import Swal from "sweetalert2";

export default function AgregarJugador() {
  const [form, setForm] = useState({ nombre: "", email: "", password:"", confirmPassword: "",
  categoria: "", puntos: 0 , dni: "", ciudad: "", genero: "" });
  const { token } = useAuth();
  const navigate = useNavigate();

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Categorías según género
  const categoriasOptions = {
    Libres: ["Suma8", "5ta", "6ta", "7ma", "8va"],
    Damas: ["Suma11", "6ta", "7ma", "8va"],}



const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");
  setSuccess("");

  // Validación de contraseñas
  if (form.password !== form.confirmPassword) {
    Swal.fire({
      title: "Error",
      text: "Las contraseñas no coinciden",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
    return;
  }

  // Validación de contraseña (mínimo 6 caracteres)
  if (form.password.length < 6) {
    Swal.fire({
      title: "Error",
      text: "La contraseña debe tener al menos 6 caracteres",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
    return;
  }

  // Validación de DNI (solo números y longitud)
  if (form.dni.length < 7 || form.dni.length > 8) {
    Swal.fire({
      title: "Error",
      text: "El DNI debe tener entre 7 y 8 dígitos",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
    return;
  }

  try {
    await api.post(
      "/registro",
      {
        nombre: form.nombre,
        email: form.email,
        password: form.password,
        categoria: form.categoria,
        puntos: Number(form.puntos),
        dni: form.dni,
        ciudad: form.ciudad,
        genero: form.genero,
        celular: form.celular,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    Swal.fire({
      title: "¡Jugador agregado!",
      text: "El jugador se ha registrado correctamente.",
      icon: "success",
      confirmButtonText: "Aceptar",
    }).then(() => {
      navigate("/admin/panel"); // Cambia la ruta si tu panel está en /admin/panel
    });
  } catch (err) {
    Swal.fire({
      title: "Error",
      text: "Hubo un problema al agregar el jugador. Por favor, verifica los datos.",
      icon: "error",
      confirmButtonText: "Aceptar",
    });
    console.error(err);
  }
};

  return (
    <div className="registro-container">
      <form className="registro-form" onSubmit={handleSubmit}>
        <h2>Registro</h2>
        
        {error && (
          <div style={{ 
            color: "white", 
            backgroundColor: "#dc3545", 
            padding: "10px", 
            borderRadius: "5px",
            marginBottom: "15px",
            textAlign: "center" 
          }}>
            {error}
          </div>
        )}
        
        {success && (
          <div style={{ 
            color: "white", 
            backgroundColor: "#28a745", 
            padding: "10px", 
            borderRadius: "5px",
            marginBottom: "15px",
            textAlign: "center" 
          }}>
            {success}
          </div>
        )}

        <div className="registro-row">
          <label>Apellido y Nombre</label>
          <input 
            placeholder="Apellido y Nombre" 
            value={form.nombre}
            onChange={e => setForm({ ...form, nombre: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>DNI</label>
          <input 
            placeholder="DNI" 
            type="number" 
            value={form.dni}
            onChange={e => setForm({ ...form, dni: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Ciudad</label>
          <input 
            placeholder="Ciudad" 
            value={form.ciudad}
            onChange={e => setForm({ ...form, ciudad: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Correo Electrónico</label>
          <input 
            placeholder="Email" 
            type="email" 
            value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })} 
            required 
          />
        </div>

        <div className="registro-row">
          <label>Celular</label>
          <input
            type="tel"
            placeholder="Celular"
            value={form.celular}
            onChange={e => setForm({ ...form, celular: e.target.value })}
            required
          />
        </div>
        
        <div className="registro-row">
          <label>Contraseña</label>
          <input 
            type="password" 
            placeholder="Contraseña (mínimo 6 caracteres)" 
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Confirmar Contraseña</label>
          <input 
            type="password" 
            placeholder="Confirmar contraseña" 
            value={form.confirmPassword}
            onChange={e => setForm({ ...form, confirmPassword: e.target.value })} 
            required 
          />
        </div>
        <div className="registro-row">
          <label>Género</label>
          <select 
            value={form.genero}
            onChange={e => setForm({ ...form, genero: e.target.value, categoria: "" })} 
            required
          >
            <option value="">Selecciona Genero</option>
            <option value="Libres">Caballeros (Libres)</option>
            <option value="Damas">Damas</option>
          </select>
        </div>
        <div className="registro-row">
          <label>Categoría</label>
          <select 
            value={form.categoria}
            onChange={e => setForm({ ...form, categoria: e.target.value })} 
            required
            disabled={!form.genero}
          >
            <option value="">Selecciona categoría</option>
            {form.genero && categoriasOptions[form.genero]?.map(cat => (
              <option key={cat} value={cat}>{cat}</option>
            ))}
          </select>
        </div>
        <button type="submit">Registrarse</button>
        <button type="button" onClick={() => navigate("/")}>Volver al inicio</button>
      </form>
    </div>
  );
}
